import api from './api-config';

// Get all data sources
export const getDataSources = async () => {
    try {
        const response = await api.get('/data-sources');
        return response.data;
    } catch (error) {
        console.error('Error fetching data sources:', error);
        throw error;
    }
};

// Create a new data source
export const createDataSource = async (dataSourceData) => {
    try {
        const response = await api.post('/data-sources', dataSourceData);
        return response.data;
    } catch (error) {
        console.error('Error creating data source:', error);
        throw error;
    }
};

// Get a specific data source
export const getDataSource = async (id) => {
    try {
        const response = await api.get(`/data-sources/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching data source ${id}:`, error);
        throw error;
    }
};

// Update a data source
export const updateDataSource = async (id, data) => {
    try {
        const response = await api.put(`/data-sources/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(`Error updating data source ${id}:`, error);
        throw error;
    }
};

// Delete a data source
export const deleteDataSource = async (id) => {
    try {
        const response = await api.delete(`/data-sources/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting data source ${id}:`, error);
        throw error;
    }
};

// Sync a data source
export const syncDataSource = async (id) => {
    try {
        const response = await api.post(`/data-sources/${id}/sync`);
        return response.data;
    } catch (error) {
        console.error(`Error syncing data source ${id}:`, error);
        throw error;
    }
};

// Refresh OAuth token for a data source
export const refreshDataSourceToken = async (id) => {
    try {
        const response = await api.post(`/data-sources/${id}/refresh-token`);
        return response.data;
    } catch (error) {
        console.error(`Error refreshing OAuth token for data source ${id}:`, error);
        throw error;
    }
};

export const getDataSourceAuthUrl = async (id) => {
    try {
        const response = await api.get(`/data-sources/${id}/auth-url`);
        return response.data;
    } catch (error) {
        console.error(`Error getting auth URL for data source ${id}:`, error);
        throw error;
    }
};

// Exchange OAuth authorization code for tokens
export const exchangeOAuthCode = async (id, codeData) => {
    try {
        const response = await api.post(`/data-sources/${id}/oauth/exchange`, codeData);
        return response.data;
    } catch (error) {
        console.error(`Error exchanging OAuth code for data source ${id}:`, error);
        throw error;
    }
};
